import { useState } from 'react';

const useFormErrorHighlight = (errorMessage) => {
    const getFieldErrorMessage = (fieldName) => {
        const fieldErrorMessage = errorMessage?.errors?.[fieldName];
        return fieldErrorMessage ? 'red' : '';
    };

    return getFieldErrorMessage;
};

export default useFormErrorHighlight;